import Home from "../pages/beauty-treasure";
import logo from "../assets/images/beautytreasure/logo.png";
import { useEffect } from "react";
const BeautyTreasure = () => {
  useEffect(() => {
    const favicon = document.getElementById("favicon");
    if (favicon) favicon.href = logo;
  }, []);
  return (
    <>
      <Home />
    </>
  );
};

export default BeautyTreasure;
